/**
 * IMPORTANT
 *
 * If you're updating any values in this file make sure to update the same values
 * in the 'colors.less' file as well.
 *
 * Both files should be sharing exactly same style properties.
 */
/**
 * Figma: Scheduled/Purple/Main
 */
const ScheduledPurpleMain = '#9862B9';
/**
 * Figma: Scheduled/Purple/Light
 */
const ScheduledPurpleLight = '#F4EDF7';
const Gray = {
    900: '#2A343C',
    800: '#555D63',
    700: '#6B7277',
    600: '#868F98',
    500: '#9199A1',
    400: '#A5AFB8',
    300: '#BAC5CF',
    200: '#E0E6EC',
    100: '#F1F4F9',
    0: '#F7F9FC',
    neutral: '#F0F0F0', // "Disabled"
};
const Primary = {
    light: '#E3F2FC',
    main: '#0075C9',
    dark: '#004A80',
    contrastWhite: '#FFFFFF',
    contrastBlack: '#000000', // required for MUI
};
const Text = {
    900: Gray[900],
    700: Gray[700],
    600: Gray[600],
};
const Icon = {
    default: Gray[700],
    background: '#E5E5E5',
};
const Error = {
    light: '#FCE3E5',
    main: '#D60916',
    dark: '#7B050D',
};
const Warning = {
    light: '#FCF2E3',
    main: '#DE8500',
    dark: '#804C00',
};
const Success = {
    light: '#E5FAF0',
    main: '#198754',
    dark: '#015F33',
};
const Important = {
    light: ScheduledPurpleLight,
    main: ScheduledPurpleMain,
    dark: '#4C215E',
};
const Sidebar = {
    baseColor: '#050E3C',
    oblivion: '#151F50',
    lightBlue: '#009BDE',
    eastBay: '#303654',
    green: '#137E4B40', // HEX #137E4B, but with 25% opacity
};
const Illustration = {
    chestwood: '#7E8EDA',
    mediumLavender: '#B388CB',
    darkLavender: ScheduledPurpleMain,
    deepPurple: '#8547AD',
    aubergine: '#4C215E',
    oceanBlue: '#4DD4FF',
    oceanGreen: '#0CEADC',
    ScheduledPurpleMain,
    ScheduledPurpleLight,
};
export const Colors = {
    primary: Primary,
    text: Text,
    icon: Icon,
    error: Error,
    warning: Warning,
    success: Success,
    important: Important,
    gray: Gray,
    illustration: Illustration,
    sidebar: Sidebar,
};
//# sourceMappingURL=Colors.constants.js.map